export default __webpack_public_path__ + "static/media/UserSetting.70289097.svg";